<template>
  <div id="app">
    <helloWorld2/>
    <!-- <img src="pictures/MSB_brigidabocini_sony-6.jpg" alt="" srcset=""> -->
   <agile class="carousel" :options="myOptions">
     <img src="pictures/MSB_brigidabocini_sony-6.jpg" alt="a" class="slide firstPic">
     <img src="pictures/MSB_brigidabocini_sony.a7-9.jpg" alt="" class="slide secondPic">
    </agile>
  </div>
</template>

<script>

import { VueAgile } from 'vue-agile';
// import HelloWorld from './components/HelloWorld.vue';
import HelloWorld2 from './components/HelloWorld2.vue';

export default {
  name: 'App',
  components: {
    HelloWorld2,
    agile: VueAgile,
  },
  data() {
    return {
      myOptions: {
        navButtons: false,
        dots: false,
        autoplay: true,
        fade: true,
        autoplaySpeed: 6000,
        speed: 1000,
        pauseOnHover: false,
      },
    };
  },
};
</script>

<style scoped>

.firstPic{
  width: 100vw;
  height:100vh;
  object-fit: cover;
  padding: 0;
  margin: 0;
}

.secondPic{
  width: 100vw;
  height:100vh;
  object-fit: cover;
  padding: 0;
  margin: 0;
}

</style>
